import { useContext, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { RebrandContext } from '../contexts/rebrandContext';

export const pagesToShowNewUi: string[] = [
  '/bp/login',
  '/bp/triage',
  '/bp/forgot-password',
  '/bp/set-password',
  '/bp/reset-password',
  '/bp/register',
  '/bp/profile',
];

export const useRebrandContext = () => {
  const { newUi, setNewUi } = useContext(RebrandContext);
  const location = useLocation();
  const showNewUi = pagesToShowNewUi.filter((url) => location.pathname.includes(url)).length > 0;
  useLayoutEffect(() => setNewUi(showNewUi), [showNewUi, setNewUi]);
  return [newUi];
};

export default useRebrandContext;
